<template lang="html">
<div class="main-body">
  <div class="main-body-search">
    <el-form :inline="true" :model="filters">
      <el-form-item>
        <el-input v-model="filters.userAccount" placeholder="用户名" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker type="date" placeholder="开始时间" style="width: 100%;"
                        v-model="filters.startTime" value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-date-picker type="date" placeholder="开始时间" style="width: 100%;"
                        v-model="filters.endTime" value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
<!--      <el-form-item>-->
<!--        <el-input v-model="filters.operationStatus" placeholder="名称" clearable></el-input>-->
<!--      </el-form-item>-->
      <el-form-item>
        <el-button type="primary" @click="fetch" >查询</el-button>
      </el-form-item>
    </el-form>
    </div>
<div class="main-body-table">
  <!--列表-->
  <el-table
    :data="tableData" style="width: 100%; height: 100%;">
    <el-table-column
      prop="userAccount"
      label="用户登录名"
      width="250">
    </el-table-column>
    <el-table-column
      label="IP 地址"
      prop="ipAddr"
      width="200">
    </el-table-column>
<!--    <el-table-column-->
<!--      prop="operateType"-->
<!--      label="操作类型"-->
<!--      width="150">-->
<!--    </el-table-column>-->
    <el-table-column
      prop="clientType"
      label="客户端"
      width="150">
    </el-table-column>
<!--    <el-table-column-->

<!--      prop="operationStatus"-->
<!--      label="操作结果"-->
<!--      width="120">-->
<!--    </el-table-column>-->
    <el-table-column
      prop="operateTime"
      label="操作时间"
      width="250">
    </el-table-column>
    <el-table-column
      prop="operation"
      label="操作描述">

    </el-table-column>
  </el-table>
  <!--工具条-->
  <el-pagination class="main-body-table-page" layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :current-page="page.current" :page-size="page.size" :total="page.total">
  </el-pagination>
</div>
</div>
</template>

<script>
import { fetchAuditLogs, fetchAuditItems } from '../../../api/sys/Audit'
export default {
  data() {
    return {
      filters: {
      name:'',
          userAccount: '',
          startTime: '',
          endTime: '',
          operationStatus: '',
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      logType: {}
    }
  },
  mounted() {
    // 默认查询
    this.load()
  },
  methods: {
    handleCurrentChange(val) {
      this.page.current = val
      this.fetch()
    },
    load() {
      fetchAuditItems().then(res => {
          res.data.forEach(d => {
            this.logType[d.code] = d.name
          })
          this.fetch()
        }).catch(err => {
          console.log(err)
        })
    },
    // 查询
    fetch() {
      fetchAuditLogs({
        userAccount: this.filters.userAccount,
        startTime: this.filters.startTime,
        endTime: this.filters.endTime,
      }).then(response => {
          response.data.forEach(row => {
              row.operation = this.findDictItemValueByItemCode(row.operation, this.utils.auditLogTranslate);
          });
          this.tableData = response.data
          this.page.total = response.total
        }).catch(err => {
          console.log(err)
        })
    },
    findDictItemValueByItemCode(itemCode, dicts) {
      if (itemCode === undefined || itemCode === null || itemCode === '') {
        return '';
      }
      if (itemCode) {
        if (dicts.filter(item => itemCode === item.key).length ==0){
          return itemCode;
        }
        return dicts.filter(item => itemCode === item.key)[0].value;
      }
    }
  }
}
</script>
<style lang="css">
</style>
